import type { LegacyMemberResult } from '~/services/LegacyEnterpriseServer/types'
import { legacyMemberStatusState } from './legacyEnterpriseMemberPending'

export interface MemberRemovalAttempt {
  requestId: string
  accepted: boolean
}

interface RemovalResponse {
  code: string
  message?: string
  data?: LegacyMemberResult
}

const DEFINITIVE_REMOVAL_REJECTIONS = new Set(['400', '403', '407', '411', '413', '425', '426', '427', '428', '430', '431', '432'])

/** 已受理只续查；网络结果不确定时用原幂等键重放，不能新建删除操作。 */
export async function runLegacyMemberRemoval(options: {
  attempt: MemberRemovalAttempt
  remove: (requestId: string) => Promise<RemovalResponse>
  query: (requestId: string) => Promise<RemovalResponse>
  remember: (attempt: MemberRemovalAttempt | null) => void
}) {
  const { attempt, remember } = options
  remember(attempt)
  const response = await (attempt.accepted ? options.query : options.remove)(attempt.requestId)
  if (response.code !== '1') {
    // 首次明确拒绝未创建任务；已受理任务的查询失败不能丢失原操作。
    if (!attempt.accepted && DEFINITIVE_REMOVAL_REJECTIONS.has(response.code)) remember(null)
    return { state: 'error' as const, message: response.message }
  }
  const state = legacyMemberStatusState(response.data)
  if (state === 'success' || state === 'failed' || (!attempt.accepted && !response.data?.status)) {
    remember(null)
    return { state: state === 'failed' ? 'failed' as const : 'success' as const }
  }
  remember({ requestId: response.data?.requestId || attempt.requestId, accepted: true })
  return { state: 'pending' as const }
}
